export default "__VITE_ASSET__UCNRgZ3u__"